import React, { useEffect, useState } from "react";
import {
  gatAllOackageWithoutPagination,
  addChallenge,
  serachByLeads,
  // getAllGroups,
} from "api/challengers/ChallengersApi";
import moment from "moment";
import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Grid,
  Row,
  Button,
} from "react-bootstrap";
import NotificationSystem from "react-notification-system";
import Card from "components/Card/Card";
import Select from "react-select";
import Datetime from "react-datetime";
import "../../../assets/css/demo.css";
import Axios from "axios";
import Swal from "sweetalert2";

const AddChallenge = (props) => {
  const _notificationSystem = React.createRef();
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const [name, setName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [organizationList, setOrganizationList] = useState([]);
  const [organisationObject, setOrganisationObject] = useState("");
  const [challengeType, setChallengeType] = useState("");
  const [startDateError, setStartDateError] = useState(null);
  const [nameError, setNameError] = useState(null);
  const [endDateError, setEndDateError] = useState(null);
  const [packageError, setPackageError] = useState(null);
  const [selectTypeError, setSelectTypeError] = useState(null);
  const [teamForms, setTeamForms] = useState([]);
  const [subscriberItems, setSubscriberItems] = useState([]);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [url, setUrl] = useState("");
  const [urlError, setUrlError] = useState(null);
  const [checkStartDateEndDateError, setCheckStartDateEndDateError] =
    useState(null);

  useEffect(() => {
    getAllOrganizationList();
  }, []);
  const getAllOrganizationList = () => {
    gatAllOackageWithoutPagination(obj).then((res) => {
      const organisationList = res.data.data.map((item) => {
        return {
          value: item.id,
          label: item.title,
        };
      });
      setOrganizationList(organisationList);
    });
  };
  const toggleAssignLeads = (index) => {
    const updatedForms = [...teamForms];
    updatedForms[index].showAssign = !updatedForms[index].showAssign;
    setTeamForms(updatedForms);
  };

  const onInputChange = (inputValue, actionMeta) => {
    if (actionMeta.action !== "input-change") return;
    if (typingTimeout) clearTimeout(typingTimeout);
    if (inputValue.trim().length === 0) return;
    const timeout = setTimeout(() => {
      handleSearch(inputValue.trim());
    }, 300);
    setTypingTimeout(timeout);
  };

  const handleSearch = async (searchTerm) => {
    try {
      const res = await serachByLeads(searchTerm, obj);
      const data = Array.isArray(res.data.data) ? res.data.data : [];
      const items = data.map((x) => ({
        value: x.id,
        label: `${x.lead_name} (${x.mobile_no})`,
      }));
      setSubscriberItems(items);
    } catch (err) {
      console.error("Search error", err);
      setSubscriberItems([]);
    }
  };

  const onSubscriberChange = (selected, index) => {
    const updatedForms = [...teamForms];
    updatedForms[index].subscriber = selected;
    setTeamForms(updatedForms);
  };
  const handleEnterName = (event) => {
    const enterName = event.target.value;
    setName(enterName);
    if (enterName) {
      setNameError(null);
    }
  };
  const handleEnterUrl = (event) => {
    const url = event.target.value;
    setUrl(url);
    if (url) {
      setUrlError(null);
    }
  };
  const handleSelectStartDate = (value) => {
    const Start_date = moment(value).format("YYYY-MM-DD");
    setStartDate(Start_date);
    if (value) {
      setStartDateError(null);
    }
  };
  const validStartDate = (current) => {
    return current.isSameOrAfter(moment(), "day");
  };
  const handleChangePackage = (value) => {
    setOrganisationObject(value);
    if (value) {
      setPackageError(null);
    }
  };
  const handleSelectEndDate = (value) => {
    const end_date = moment(value).format("YYYY-MM-DD");
    setEndDate(end_date);

    if (value) {
      setEndDateError(null);

      if (startDate && moment(startDate).isAfter(moment(end_date))) {
        setCheckStartDateEndDateError(
          <small className="text-danger" style={{ marginLeft: "8px" }}>
            Start Date must be before or equal to End Date.
          </small>
        );
      } else {
        setCheckStartDateEndDateError(null);
      }
    }
  };

  const onSubmit = async () => {
    let error = false;
    const notification = _notificationSystem.current;

    if (!notification) {
      console.error("Notification system not available");
      return;
    }

    if (!startDate) {
      error = true;
      setStartDateError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          Start Date is required.
        </small>
      );
    } else {
      setStartDateError(null);
    }

    if (!endDate) {
      error = true;
      setEndDateError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          End Date is required.
        </small>
      );
    } else {
      setEndDateError(null);
    }

    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
      error = true;
      setCheckStartDateEndDateError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          End Date must be after Start Date.
        </small>
      );
    } else {
      setCheckStartDateEndDateError(null);
    }

    if (!name) {
      error = true;
      setNameError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          Name is required.
        </small>
      );
    } else {
      setNameError(null);
    }
    if (!url) {
      error = true;
      setUrlError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          Dashboard Url is required.
        </small>
      );
    } else {
      setUrlError(null);
    }

    if (!organisationObject) {
      error = true;
      setPackageError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          Package is required.
        </small>
      );
    } else {
      setPackageError(null);
    }

    if (!challengeType) {
      error = true;
      setSelectTypeError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          Select Type is required.
        </small>
      );
    } else {
      setSelectTypeError(null);
    }

    if (error) return;

    const teamData = teamForms.map((form) => ({
      name: form.name,
      product_code: form.code,
      profile_url: typeof form.logoData === "string" ? form.logoData : "",
      assign_leads: form.subscriber
        ? form.subscriber.map((s) => Number(s.value))
        : [],
    }));

    const challenge = {
      name,
      start_date: startDate,
      end_date: endDate,
      dashboard_url: url,
      package_id:
        organisationObject && organisationObject.value
          ? organisationObject.value
          : null,
      is_active: true,
      type: challengeType || null,
      teams: teamData,
    };

    try {
      await addChallenge(challenge, obj);

      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift" />,
        message: (
          <div>
            <b>Challenge</b> added successfully.
          </div>
        ),
        level: "success",
        position: "bl",
        autoDismiss: 15,
      });

      setName("");
      setStartDate("");
      setEndDate("");
      setOrganisationObject(null);
      setChallengeType("");
      setTeamForms([]);

      setTimeout(() => {
        props.history.push("/admin/Challengers");
      }, 3000);
    } catch (err) {
      console.error("Add challenge failed:", err);

      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift" />,
        message: (
          <div>
            <b>Error: {err.message || "Failed to add challenge"}</b>
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };

  const handleEnter = (index, event) => {
    const newForms = [...teamForms];
    newForms[index].name = event.target.value;
    setTeamForms(newForms);
  };

  const handleCode = (index, event) => {
    const newForms = [...teamForms];
    newForms[index].code = event.target.value;
    setTeamForms(newForms);
  };

  const handleImageChange = async (index, e) => {
    const file = e.target.files[0];
    const fdata = new FormData();
    fdata.append("company_logo", file);
    const token = JSON.parse(localStorage.getItem("user")).token;

    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_NOT_SECRET_CODE}/b2b/comapany/logo`,
        fdata,
        {
          headers: {
            Authorization: "Bearer " + token,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "X-Request-Id": "124",
          },
        }
      );

      const imageUrl = res.data.data.company_logo_url;
      const newForms = [...teamForms];
      newForms[index].logo = file;
      newForms[index].logoData = imageUrl;
      setTeamForms(newForms);
    } catch (error) {
      console.error("Image upload error", error);
    }
  };
  const removeForm = (index) => {
    const updatedForms = [...teamForms];
    updatedForms.splice(index, 1);
    setTeamForms(updatedForms);
  };

  const pushImage = (index) => {
    document.getElementById(`selectImageProfile-${index}`).click();
  };
  const handleAddForm = () => {
    setTeamForms([
      ...teamForms,
      {
        name: "",
        code: "",
        logo: "",
        logoData: "",
        showAssign: false,
        subscriber: null,
      },
    ]);
  };

  return (
    <div className="main-content">
      <Grid fluid>
        <NotificationSystem ref={_notificationSystem} />
        <Row>
          <Col md={6}>
            <Card
              content={
                <form>
                  <FormGroup>
                    <ControlLabel>Challenge Name</ControlLabel>
                    <FormControl
                      type="text"
                      name="name"
                      placeholder="Challenge Name"
                      onChange={handleEnterName}
                      value={name}
                      style={{ width: "100%" }}
                    />
                    {nameError}
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Start Date</ControlLabel>
                    <Datetime
                      timeFormat={false}
                      dateFormat="YYYY-MM-DD"
                      closeOnSelect
                      value={startDate || ""}
                      isValidDate={validStartDate}
                      onChange={handleSelectStartDate}
                      inputProps={{
                        placeholder: "Select Start Date",
                        style: { width: "100%" },
                      }}
                    />
                    {startDateError}
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>End Date</ControlLabel>
                    <Datetime
                      timeFormat={false}
                      dateFormat="YYYY-MM-DD"
                      closeOnSelect
                      value={endDate || ""}
                      isValidDate={validStartDate}
                      onChange={handleSelectEndDate}
                      inputProps={{
                        placeholder: "Select End Date",
                        style: { width: "100%" },
                      }}
                    />
                    {endDateError} {checkStartDateEndDateError}
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Select Package</ControlLabel>
                    <Select
                      style={{ width: "100%" }}
                      value={organisationObject}
                      placeholder="Select Package"
                      options={organizationList}
                      onChange={(value) => handleChangePackage(value)}
                    />
                    {packageError}
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Select Type</ControlLabel>
                    <select
                      onChange={(event) => {
                        setChallengeType(event.target.value);
                        if (event.target.value) {
                          setSelectTypeError(null);
                        }
                      }}
                      value={challengeType}
                      className="form-control"
                    >
                      <option value="">Challenge type</option>
                      <option value="steps">steps</option>
                      <option value="calorie">calorie</option>
                    </select>
                    {selectTypeError}
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Dashboard Url</ControlLabel>
                    <FormControl
                      type="text"
                      name="Dashboard Url"
                      placeholder="Dashboard Url"
                      onChange={handleEnterUrl}
                      value={url}
                      style={{ width: "100%" }}
                    />
                    {urlError}
                  </FormGroup>
                  <div>
                    <Button onClick={handleAddForm}>
                      Add Team <i className="fa fa-plus"></i>
                    </Button>

                    {teamForms.length > 0 && (
                      <>
                        <br />
                        <br />
                        {teamForms.map((form, index) => (
                          <div
                            key={index}
                            style={{
                              width: "90%",
                              margin: "0 auto",
                              boxShadow:
                                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
                              padding: "20px",
                              marginBottom: "20px",
                              borderRadius: "8px",
                              backgroundColor: "#f3f3f3",
                              position: "relative",
                            }}
                          >
                            <button
                              onClick={() => removeForm(index)}
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                background: "transparent",
                                border: "none",
                                fontSize: "20px",
                                cursor: "pointer",
                                color: "#999",
                              }}
                              title="Remove Form"
                            >
                              &times;
                            </button>

                            <div
                              style={{
                                display: "flex",
                                gap: "20px",
                                marginBottom: "10px",
                              }}
                            >
                              <FormGroup style={{ flex: 1 }}>
                                <ControlLabel>Team Name</ControlLabel>
                                <FormControl
                                  type="text"
                                  placeholder="Enter Name"
                                  onChange={(e) => handleEnter(index, e)}
                                  value={form.name}
                                />
                              </FormGroup>

                              <FormGroup style={{ flex: 1 }}>
                                <ControlLabel>Team Code</ControlLabel>
                                <FormControl
                                  type="text"
                                  placeholder="Product Code"
                                  onChange={(e) => handleCode(index, e)}
                                  value={form.code}
                                />
                              </FormGroup>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                gap: "20px",
                                alignItems: "center",
                              }}
                            >
                              <FormGroup>
                                <ControlLabel>Upload Team Logo</ControlLabel>
                                <br />
                                <input
                                  style={{ display: "none" }}
                                  id={`selectImageProfile-${index}`}
                                  type="file"
                                  accept="image/*"
                                  className="form-control"
                                  onChange={(e) => handleImageChange(index, e)}
                                />
                                <Button
                                  onClick={() => pushImage(index)}
                                  style={{ color: "#2B3A41" }}
                                >
                                  <i
                                    className={
                                      form.logo === ""
                                        ? "fa fa-plus"
                                        : "fa fa-pencil fa-fw"
                                    }
                                  ></i>{" "}
                                  {form.logo === ""
                                    ? "Choose Logo"
                                    : "Change Logo"}
                                </Button>
                              </FormGroup>

                              {(form.logo || form.logoData) && (
                                <img
                                  src={
                                    typeof form.logo === "string"
                                      ? form.logo
                                      : URL.createObjectURL(form.logo)
                                  }
                                  alt="Logo"
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                    marginLeft: "10px",
                                  }}
                                />
                              )}
                            </div>
                            {form.showAssign ? (
                              <div
                                style={{
                                  gap: "10px",
                                  flex: 1,
                                  alignItems: "end",
                                }}
                              >
                                <div style={{ marginBottom: "16px" }}>
                                  <Button
                                    onClick={() => toggleAssignLeads(index)}
                                  >
                                    Assign Leads{" "}
                                    <i className="fa fa-user-plus" />
                                  </Button>
                                </div>
                                <div style={{ flex: 1 }}>
                                  <FormGroup>
                                    <ControlLabel>Select Customer</ControlLabel>
                                    <Select
                                      className="react-select primary"
                                      classNamePrefix="react-select"
                                      name="subscriber"
                                      closeMenuOnSelect={false}
                                      value={form.subscriber}
                                      onChange={(selected) =>
                                        onSubscriberChange(selected, index)
                                      }
                                      onInputChange={onInputChange}
                                      isMulti
                                      options={subscriberItems}
                                      placeholder="Type Name or Phone Number"
                                      noOptionsMessage={() =>
                                        "No Subscribers Found"
                                      }
                                    />
                                  </FormGroup>
                                </div>
                              </div>
                            ) : (
                              <div style={{ marginTop: "8px" }}>
                                <Button
                                  onClick={() => toggleAssignLeads(index)}
                                >
                                  Assign Leads <i className="fa fa-user-plus" />
                                </Button>
                              </div>
                            )}
                          </div>
                        ))}
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                          <Button
                            onClick={handleAddForm}
                            className="add-button"
                          >
                            Add Team <i className="fa fa-plus"></i>
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                  <Button
                    className="btn-color"
                    onClick={() => onSubmit()}
                    style={{ marginTop: "20px" }}
                  >
                    Submit
                  </Button>
                  <br />
                </form>
              }
            />
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default AddChallenge;
